import bugsnag from '@bugsnag/js'
const bugsnagClient = bugsnag({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    releaseStage: process.env.MIX_APP_ENV,
    notifyReleaseStages: process.env.MIX_BUGSNAG_NOTIFY_RELEASE_STAGES.split(',')
})
export { bugsnagClient as bugsnagClient }